<template>
  <div class="card bg-primary-translucent border-0">
    <div class="card-body p-3">
      <template v-if="emailSent">
        <p>
          {{ i18n.t('member.petitions.start.request_help.email_sent_to') }}
        </p>
        <p class="fw-bold">
          {{ emailAddress }}
        </p>
        <p class="mb-0">
          {{ i18n.t('member.petitions.start.request_help.email_sent_explanation') }}
        </p>
      </template>
      <template v-else>
        <p class="fw-bold">
          {{ i18n.t('member.petitions.start.request_help.intro') }}
        </p>
        <p>
          {{ getHelpText }}
        </p>

        <form class="d-flex flex-row flex-xl-column">
          <text-input v-if="showEmailField" autocomplete="email" input-type="email" :value="emailAddress"
                      :placeholder="i18n.t('activerecord.attributes.member.email')"
                      :validation-errors="validationErrors" class="flex-grow-1 mb-1 mb-xl-3" @changed="updateEmail" />

          <div class="flex-shrink-0 ps-3 ps-xl-0">
            <button type="submit" :disabled="submitting" class="btn btn-dark" @click.prevent="submit">
              {{ i18n.t('member.petitions.start.request_help.submit') }}
            </button>
          </div>
        </form>
      </template>
    </div>
  </div>
</template>

<script>
import ajax from '../../helpers/ajax'
import { mapState } from 'vuex'
import TextInput from '@/components/inputs/text-input'

export default {
  components: { TextInput },

  data() {
    return {
      emailAddress: null,
      emailSent: false,
      submitting: false,
      validationErrors: []
    }
  },

  computed: {
    ...mapState(['requestHelpUrl', 'userLoggedIn']),

    getHelpText() {
      const withOrWithout = this.userLoggedIn ? 'without' : 'with'
      return this.i18n.t(`member.petitions.start.request_help.text_${withOrWithout}_enter_email`)
    },

    showEmailField() {
      return !this.userLoggedIn
    }
  },

  methods: {
    submit() {
      this.submitting = true

      ajax.post({
        url: this.requestHelpUrl,
        data: {
          petition_start: {
            email: this.emailAddress
          }
        },
        successHandler: ({ emailSentTo }) => {
          this.emailSent = true
          this.emailAddress = emailSentTo
          this.$store.commit('setHelpRequested')
        },
        errorHandler: ({ info }) => {
          this.validationErrors = info.errors.email
        }
      }).then(() => {
        this.submitting = false
      })
    },

    updateEmail(value) {
      this.emailAddress = value
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 1rem;
  line-height: 1.5;
}

::v-deep(input) {
  height: 50px;
}

button {
  height: 50px;
}

// Make sure help widget is displayed in the front to avoid not being behind
// floating Submit button
.card {
  z-index: 999;
}
</style>
